import clockIcon from '~/assets/images/onboarding/clockIcon.webp'
import customizeIcon from '~/assets/images/onboarding/customizeIcon.webp'
import notificationsIcon from '~/assets/images/onboarding/notificationsIcon.webp'
import { EClientPath } from '~/models/api'
import rem from '~/utils/ui'

export const onboardingBasicInfoTexts = [
  {
    iconSrc: clockIcon,
    text: (
      <>
        <strong> Easily integrate{` `}</strong>
        with popular CRM tools like Salesforce and HubSpot
      </>
    ),
  },
  {
    iconSrc: customizeIcon,
    text: (
      <>
        <strong>Customize{` `}</strong>
        your assistant’s appearance to match your brand
      </>
    ),
  },
  {
    iconSrc: notificationsIcon,
    text: (
      <>
        <strong>Instant notifications{` `}</strong>
        for new leads and appointments
      </>
    ),
  },
]

export const TRY_IT_OUT_VIDEO_URL =
  'https://player.vimeo.com/video/992186432?badge=0&amp;autopause=0&amp;player_id=0&amp;app_id=58479'

export const buildDemoOnboardingPath = (
  partialPathFragment: EClientPath,
): EClientPath => {
  const isDemo = window.location.pathname.includes(EClientPath.demoBase)
  return ((isDemo ? EClientPath.demoBase : EClientPath.onboardingBase) +
    partialPathFragment) as EClientPath
}

export const vhCalc = (valueInPx: number, coefficient = 1) => {
  return `max(${valueInPx * 0.6 * (1 / coefficient)}px, min(${((valueInPx / (1100 * coefficient)) * 100).toFixed(2)}vh, ${rem(valueInPx)}))`
}

export const getVhCoefficient = (valueInAnything: number) => {
  return Number(
    Math.max(
      valueInAnything * 0.8,
      Math.min((valueInAnything / 1200) * 100, valueInAnything),
    ).toFixed(2),
  )
}
